import { Prec } from "@codemirror/next/state";
import { keymap } from "@codemirror/next/view";
import { LanguageSupport } from "@codemirror/next/language";
import { markdownLanguage, markdownWithCodeLanguages } from "./markdown";
import { insertNewlineContinueMarkup, deleteMarkupBackward } from "./commands";
export { markdownLanguage, insertNewlineContinueMarkup, deleteMarkupBackward };
/// A small keymap with Markdown-specific bindings. Binds Enter to
/// [`insertNewlineContinueMarkup`](#lang-markdown.insertNewlineContinueMarkup)
/// and Backspace to
/// [`deleteMarkupBackward`](#lang-markdown.deleteMarkupBackward).
export const markdownKeymap = [
    { key: "Enter", run: insertNewlineContinueMarkup },
    { key: "Backspace", run: deleteMarkupBackward }
];
/// Markdown language support.
export function markdown(config = {}) {
    let { codeLanguages, defaultCodeLanguage, addKeymap = true } = config;
    let language = codeLanguages || defaultCodeLanguage ? markdownWithCodeLanguages(codeLanguages || [], defaultCodeLanguage)
        : markdownLanguage;
    return new LanguageSupport(language, addKeymap ? Prec.extend(keymap.of(markdownKeymap)) : []);
}
